// extracted by mini-css-extract-plugin
module.exports = {"container":"numeric-updown_container__6_kjZ","button":"numeric-updown_button__3uO_L","input":"numeric-updown_input__2SFC3"};